module.exports = __webpack_public_path__ + "static/3dgence-printer-9b831fc6345d0df47e0b749b828258a8.png";